export enum ResultsMode {
    Eligible = 'Eligible',
    Simple = 'Simple',
    Ineligible = 'Ineligible'
}

export enum PricingCode {
    InitialPricing = 'InitialPricing',
    DealDeskPricing = 'DealDeskPricing',
    PreApprovedPricing = 'PreApprovedPricing',
    ReadyToLock = 'ReadyToLock',
    LockRequested = 'LockRequested',
    Locked = 'Locked',
    Archived = 'Archived'
}
